import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  isIframe = false;

  ngOnInit(): void {
    // Detect if running inside MSAL's silent token renewal iframe
    this.isIframe = window !== window.parent && !window.opener;
  }
}
